const setup = () => ({
  cropAt: 265,
  noteWidth: 240,
  colWidth: 240,
  gap: 20,
  numColumns: 1,
  indexedDBName: 'notes-local-db',
  notesAPI: 'https://notes.svetilo.ru/api/notes',
  usersAPI: 'https://notes.svetilo.ru/api/users',
  healthAPI: 'https://notes.svetilo.ru/api/health',
  connectInterval: 50000, // keep connection timeout
  fetchArraySize: 1000, // number of notes in single fetch from server
});

export default setup();